import Swiper from 'swiper/swiper-bundle';

export default new class resourcesSlider {
  init() {
    const powRows = document.querySelectorAll('.pow-row');

    powRows.forEach(function (powRow) {
      const resourcesSlider = powRow.querySelector('.resources-slider');

      if( typeof resourcesSlider !== 'undefined') {
        const swiperEl = new Swiper(resourcesSlider, {
          // Optional parameters
          loop: true,
          slidesPerView: 1,
          spaceBetween: 16,
          centerInsufficientSlides: true,
          breakpoints: {
            // when window width is >= 600px
            600: {
              slidesPerView: 2,
            },
            // when window width is >= 1024px
            1024: {
              slidesPerView: 3,
            }
          },
          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
          },

          // Navigation arrows
          navigation: {
            nextEl: powRow.querySelector('.swiper-button-next'),
            prevEl: powRow.querySelector('.swiper-button-prev'),
          },
        });
      }
    });
  }
}